<template>
  <div>
    <div v-if="!isLoading">
      <div class="d-flex showcase">
        <div class="photos bd-highlight mr-4" v-if="product.slides.length > 1">
          <VueSlickCarousel v-bind="settings" :focusOnSelect="true">
            <template v-for="(slide, index) in product.slides">
              <div class="slick-item" :key="index" @click="changeSlide(index)">
                <img :src="slide" alt="" />
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="preview bd-highlight">
          <img v-if="product.cover" ref="cover" :src="product.cover" alt="" />
          <img
            v-else
            ref="cover"
            src="@/assets/img/pexels-photo-106399.jpeg"
            alt=""
          />
        </div>
        <div v-if="product" class="info flex-grow-1 bd-highlight">
          <div class="flex-grow-1">
            <h2>{{ product.name }}</h2>
            <div class="category">
              <span>Danh mục: </span>
              <span>{{ product.category_name }}</span>
            </div>
            <div class="brand">
              <span>Thương hiệu: </span>
              <span>{{ product.brand_name }}</span>
            </div>
            <div class="available-status">
              <span>Trạng thái: </span>
              <span v-if="product.is_available == 1" class="available"
                >Hàng có sẵn</span
              >
              <span v-else class="order">Hàng order</span>
            </div>
            <div class="price">
              <span>Giá: </span>
              <span v-if="product.price">{{ product.price }} VND</span>
              <span v-else>Liên hệ</span>
            </div>
            <div class="description">
              <span>Môt tả:</span>
              <p>
                {{ product.description }}
              </p>
            </div>
            <div class="actions">
              <PrimaryButton caption="Liên hệ đặt mua" @onClick="order()" />
            </div>
          </div>
        </div>
      </div>
      <RelatedProducts :products="relatedProducts" />
    </div>
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");

import RelatedProducts from "./components/RelatedProducts.vue";
import Loading from "./components/Loading.vue";
import PrimaryButton from "./components/PrimaryButton.vue";
export default {
  components: {
    VueSlickCarousel,
    RelatedProducts,
    Loading,
    PrimaryButton,
  },
  data() {
    return {
      settings: {
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1660,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: true,
              verticalSwiping: true,
              arrows: true,
            },
          },
          {
            breakpoint: 1279,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: true,
              verticalSwiping: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: false,
              verticalSwiping: false,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              vertical: false,
              verticalSwiping: false,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  created() {
    const productId = this.$route.params.id;
    // productId && this.getProduct(productId);
  },
  methods: {
    ...mapActions(["getProduct"]),

    changeSlide(index) {
      const { slides } = this.product;
      this.$refs.cover.setAttribute("src", slides[index]);
    },

    order() {
      window.open("https://zalo.me/0937776602", "_blank");
    },
  },
  computed: {
    ...mapState(["product", "isLoading", "relatedProducts"]),
  },
};
</script>

<style lang="scss" scoped>
.showcase {
  position: relative;
  display: flex;
  .photos {
    max-width: 200px;
    max-height: 600px;
    overflow: hidden;
    margin-right: 10px;
    padding-top: 35px;
  }
  ::v-deep .slick-slider {
    height: 472px;
    position: relative;
    padding: 16px 0;
    .slick-arrow.slick-next {
      position: absolute;
      top: -5px;
      left: 50%;
      transform: translateX(-50%) rotate(270deg);
    }
    .slick-arrow.slick-prev {
      position: absolute;
      left: 50%;
      top: 447px;
      transform: translateX(-50%) rotate(-90deg);
    }
  }
  .slick-item {
    img {
      width: 200px;
      height: 100px;
      object-fit: cover;
    }
  }
  .preview {
    margin-right: 10px;
    padding-top: 50px;
    img {
      margin-top: 1px;
      width: 600px;
      height: 428px;
      object-fit: cover;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    height: 480px;
    position: relative;
    padding-top: 50px;
    .category {
      color: #000;
      font-size: 22px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .brand {
      color: #000;
      font-size: 22px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .available-status {
      color: #000;
      font-size: 20px;
      // text-transform: uppercase;
      margin-bottom: 10px;
      .available {
        color: #50e443;
      }
      .order {
        color: #d39999;
      }
    }
    .price {
      color: #000;
      font-size: 22px;
      margin-bottom: 10px;
      span:nth-child(2) {
        color: #d39999 !important;
      }
    }
    .description {
      font-size: 16px;
      margin-top: 25px;
      color: #000;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5; /* number of lines to show */
        line-clamp: 5;
        -webkit-box-orient: vertical;
      }
    }
    .actions {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .showcase {
    padding: 50px 80px 0 80px;

    .photos {
      max-width: 125px;
      max-height: 500px;
    }
    .preview {
      img {
        width: 500px;
        height: 428px;
        object-fit: cover;
      }
    }
    .info {
      height: 480px;
      .category,
      .brand,
      .available-status,
      .price,
      .group {
        margin-bottom: 2px;
      }
      .description {
        margin-top: 0;
        p {
          -webkit-line-clamp: 4;
        }
      }
      h2 {
        font-size: 1.825rem;
      }
      span {
        font-size: 18px;
      }
    }
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .showcase {
    padding: 40px 60px 0 60px;

    flex-wrap: wrap;
    .photos {
      max-width: 180px;
      max-height: 400px;
      ::v-deep .slick-slider {
        .slick-arrow.slick-prev {
          top: 340px;
        }
      }
    }
    .preview {
      img {
        width: 460px;
        height: 319px;
        object-fit: cover;
      }
    }
    .info {
      height: 370px;

      flex: 1 1 100%;

      .category,
      .brand,
      .available-status,
      .price,
      .group {
        margin-bottom: 2px;
      }
      .description {
        margin-top: 0;
        p {
          -webkit-line-clamp: 4;
        }
      }
      h2 {
        font-size: 1.5rem;
      }
      span {
        font-size: 14px;
      }
    }
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .showcase {
    padding: 20px 40px 0 40px;
    flex-direction: column;
    .photos {
      max-width: 100%;
      ::v-deep .slick-slider,
      ::v-deep .slick-list {
        height: 120px !important;
      }
      img {
        width: 200px;
        height: 170px;
      }
    }
    .preview {
      margin-left: unset;
      margin-bottom: 30px;
      padding-top: 16px;
      img {
        width: 100%;
        height: 400px;
      }
    }
    .info {
      height: 325px;
      .category,
      .brand,
      .available-status,
      .price,
      .group {
        margin-bottom: 2px;
      }
      .description {
        margin-top: 0;
        p {
          -webkit-line-clamp: 4;
        }
      }
      h2 {
        font-size: 1.5rem;
      }
      span {
        font-size: 14px;
      }
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  .showcase {
    flex-direction: column;
    .photos {
      max-width: 100%;
      ::v-deep .slick-slider,
      ::v-deep .slick-list {
        height: 100px !important;
      }
      img {
        width: 80px;
        height: 50px;
      }
    }
    .preview {
      margin-left: unset;
      margin-bottom: 30px;
      padding-top: 0;
      img {
        width: 100%;
        height: 200px;
      }
    }
  }
}
</style>
